import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PLAY_PREVIOUS } from '../../actions/Playback';
export default function PreviousButton(props) {
    var _a, _b, _c;
    useEffect(() => { var _a, _b; return (_b = (_a = navigator) === null || _a === void 0 ? void 0 : _a.mediaSession) === null || _b === void 0 ? void 0 : _b.setActionHandler('previoustrack', triggerPrevious); }, []);
    const dispatch = useDispatch();
    const { previous } = useSelector((state) => state.PlaybackStates);
    const { mediaId } = useSelector((state) => state.Media);
    const triggerPrevious = () => dispatch({ type: PLAY_PREVIOUS, payload: { mediaId } });
    if (!previous) {
        return React.createElement("div", { style: { display: 'none' } });
    }
    return (React.createElement("music-button", { ariaLabelText: (_a = previous) === null || _a === void 0 ? void 0 : _a.description, disabled: false, className: ((_b = previous) === null || _b === void 0 ? void 0 : _b.isDisabled) ? 'disabled hydrated sc-music-button-h' : 'hydrated sc-music-button-h', onmusicActivate: triggerPrevious, variant: "primary", "icon-name": "previous", "icon-only": true, size: props.size || 'small' }, (_c = previous) === null || _c === void 0 ? void 0 : _c.description));
}
;
